var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00011,
    cy: 12.0115,
    r: 2.14232,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85727 3.13422C5.85727 2.56819 6.08298 2.02534 6.48483 1.62509C6.88669 1.22485 7.43173 1 8.00009 1C8.56845 1 9.1135 1.22485 9.51535 1.62509C9.91721 2.02534 10.1429 2.56819 10.1429 3.13422V8.87283C9.87921 8.69245 9.59162 8.54444 9.28586 8.43452V3.13422C9.28586 2.7946 9.15036 2.46889 8.90927 2.22874C8.66806 1.9886 8.34104 1.85368 8.00009 1.85368C7.65915 1.85368 7.33212 1.9886 7.09091 2.22874C6.84982 2.46889 6.71433 2.7946 6.71433 3.13422V8.43455C6.40856 8.54448 6.12097 8.6925 5.85727 8.87288V3.13422Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00201 11.904C5.00248 11.8912 5.00303 11.8784 5.00366 11.8656C5.04002 11.1062 5.3588 10.4207 5.85727 9.91199C6.1033 9.66092 6.3931 9.45286 6.71433 9.30025C6.98078 9.17365 7.26886 9.0852 7.5715 9.0419V4.66129C7.5715 4.54808 7.61667 4.43952 7.69699 4.35947C7.77744 4.27942 7.88645 4.23444 8.00009 4.23444C8.11374 4.23444 8.22275 4.27942 8.30319 4.35947C8.38352 4.43952 8.42868 4.54808 8.42868 4.66129V9.04188C8.54746 9.05886 8.66399 9.08281 8.77785 9.11328C10.0577 9.45585 11.0001 10.6236 11.0001 12.0115C11.0001 13.6684 9.65699 15.0115 8.00013 15.0115C7.99393 15.0115 7.98773 15.0115 7.98154 15.0115C7.88841 15.0109 7.79628 15.0061 7.70534 14.9972C6.25032 14.8553 5.09993 13.6739 5.00632 12.2052C5.00544 12.1917 5.00466 12.1781 5.00396 12.1646C5.00141 12.1139 5.00012 12.0628 5.00012 12.0115C5.00012 11.9755 5.00076 11.9397 5.00201 11.904ZM10.1425 12.0115C10.1425 13.1947 9.18333 14.1538 8.00016 14.1538C6.81699 14.1538 5.85784 13.1947 5.85784 12.0115C5.85784 10.8283 6.81699 9.86919 8.00016 9.86919C9.18333 9.86919 10.1425 10.8283 10.1425 12.0115Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.151ecbbcd662c24300b7145d774c7d42.svg";
export { ForwardRef as ReactComponent };